import React, { Component, createRef } from "react";

import {
  Button,
  Container,
  Row,
  Form,
  Col,
  Offcanvas,
  Modal,
} from "react-bootstrap";

import { toast } from "react-toastify";

import DataTable from "react-data-table-component";

import configData from "../config.json";

import ReactQuill from "react-quill";

import LoadingOverlay from "./LoadingOverlay";
import "react-quill/dist/quill.snow.css";

export default class Emailtemplates extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,

      data: [],

      sId: sessionStorage.getItem("sessionId"),

      uId: sessionStorage.getItem("uId"),

      errors: {},

      filteredData: null,

      tableClms: [
        {
          name: "S.NO",

          selector: (row, i) => row.emailtemplates_Id,

          sortable: true,

          cell: (row) => <span>{row.emailtemplates_Id}</span>,
        },

        {
          name: "Name",

          selector: (row, i) => row.name,

          sortable: true,

          cell: (row) => <span>{row.name}</span>,
        },

        {
          name: "Subject Template",

          selector: (row, i) => row.subjectTemplate,

          sortable: true,

          cell: (row) => <span>{row.subjectTemplate}</span>,
        },

        // {

        //   name: "Body Template",

        //   selector: (row, i) => row.bodyTemplate,

        //   sortable: true,

        //   cell: (row) => <span>{row.bodyTemplate}</span>,

        // },

        {
          name: "Is Html",

          selector: (row, i) => row.isHtml,

          sortable: true,

          cell: (row) => <span>{row.isHtml}</span>,
        },

        {
          name: "Variables JSON",

          selector: (row, i) => row.variablesJSON,

          sortable: true,

          cell: (row) => <span>{row.variablesJSON}</span>,
        },

        {
          name: "Is Active",

          selector: (row, i) => row.isActive,

          sortable: true,

          cell: (row) => <span>{row.isActive}</span>,
        },

        // {

        //   name: "Container Height",

        //   selector: (row, i) => row.dummyOne,

        //   sortable: true,

        //   cell: (row) => <span>{row.dummyOne}</span>,

        // },

        // {

        //   name: "Container Weight",

        //   selector: (row, i) => row.dummyTwo,

        //   sortable: true,

        //   cell: (row) => <span>{row.dummyTwo}</span>,

        // },

        // {

        //   name: "To",

        //   selector: (row, i) => row.to,

        //   sortable: true,

        //   cell: (row) => <span>{row.to}</span>,

        // },

        // {

        //   name: "CC",

        //   selector: (row, i) => row.cc,

        //   sortable: true,

        //   cell: (row) => <span>{row.cc}</span>,

        // },

        // {

        //   name: "BCC",

        //   selector: (row, i) => row.bcc,

        //   sortable: true,

        //   cell: (row) => <span>{row.bcc}</span>,

        // },

        {
          name: "Is Template has Attachment",
          selector: (row, i) => row.isTemplatehasAttachment,
          sortable: true,
          cell: (row) => <span>{row.isTemplatehasAttachment}</span>,
        }, //***tableClms

        {
          name: "Actions",

          sortable: false,

          cell: (row) => (
            <div>
              {/* edit button and delete button */}

              <Button
                style={{ marginRight: "5px" }}
                variant="primary"
                onClick={() => this.EmailtemplateseditHandler(row)}
                className="bi bi-pen"
                title="Edit"
              ></Button>

              <Button
                style={{ marginRight: "5px" }}
                variant="info"
                onClick={() => this.handlePreview(row)}
                className="bi bi-eye"
                title="Preview"
              ></Button>

              <Button
                style={{ marginRight: "5px", marginTop: "0px" }}
                variant="success"
                onClick={() => this.handleTestEmail(row)}
                className="bi bi-envelope"
                title="Test Email"
              ></Button>

              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
                title="Delete"
              ></Button>
            </div>
          ),
        },
      ],

      currentPage: 1,

      itemsPerPage: 100,

      isEditing: false,

      emailtemplates_Id: "",

      name: "",

      subjectTemplate: "",

      bodyTemplate: "",

      isHtml: "",

      variablesJSON: "",

      isActive: "",

      dummyOne: "",

      dummyTwo: "",

      dummyThree: "",

      dummyFour: "",

      dummyFive: "",

      to: "",

      cc: "",

      bcc: "",

      attachment: "",

      // Test email functionality

      showTestModal: false,

      testEmail: "",

      testVariables: "",

      showPreviewModal: false,

      previewData: null,

      sendingTest: false,

      generatingPreview: false,

      isTemplatehasAttachment: "",
      isTemplatehasAttachments: "",
      showSource: false,
      //***state
    };
    this.quillRef = createRef();
  }

  // offcanvas Open

  handleOffcanvasShow = () => {
    this.setState({
      show: true,

      name: "",

      subjectTemplate: "",

      bodyTemplate: "",

      isHtml: "",

      variablesJSON: "",

      isActive: "",

      dummyOne: "",

      dummyTwo: "",

      dummyThree: "",

      dummyFour: "",

      dummyFive: "",

      to: "",

      cc: "",

      bcc: "",

      attachment: "",
    });
  };

  // Offcanvas close button

  handleOffcanvasClose = () => {
    this.setState({
      show: false,

      isEditing: false,

      name: "",

      subjectTemplate: "",

      bodyTemplate: "",

      isHtml: "",

      variablesJSON: "",

      isActive: "",

      dummyOne: "",

      dummyTwo: "",

      dummyThree: "",

      dummyFour: "",

      dummyFive: "",

      to: "",

      cc: "",

      bcc: "",

      attachment: "",
    });
  };

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);

        break;

      case "error":
        toast.error(msg);

        break;

      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'

        break;

      default:
        toast.info(msg);
    }
  };

  EmailtemplateseditHandler = (row) => {
    // e.preventDefault();

    this.setState({
      isEditing: true,

      emailtemplates_Id: row.emailtemplates_Id,

      name: row.name,

      subjectTemplate: row.subjectTemplate,

      bodyTemplate: row.bodyTemplate,

      isHtml: row.isHtml,

      variablesJSON: row.variablesJSON,

      isActive: row.isActive,

      dummyOne: row.dummyOne,

      dummyTwo: row.dummyTwo,

      dummyThree: row.dummyThree,

      dummyFour: row.dummyFour,

      dummyFive: row.dummyFive,

      to: row.to,

      cc: row.cc,

      bcc: row.bcc,

      attachment: row.attachment,
      isTemplatehasAttachment: row.isTemplatehasAttachment, //***editstate
    });
  };

  EmailtemplatesfetchHandler = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Emailtemplates/list", {
      // Enter your IP address here

      method: "POST",

      //headers :{ 'Content-Type' : 'application/json'},

      mode: "cors",

      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };

  EmailtemplatessubmitHandler = (e) => {
    e.preventDefault();

    let cleanBodyTemplate = this.state.bodyTemplate

      .replaceAll('<p class="ql-align-justify">', "")

      .replaceAll("<p>", "")

      .replaceAll("</p>", "<br/>") // convert end of paragraph to a line break

      .replaceAll("<br/><br/>", "<br/>") // prevent double breaks

      .replaceAll("<br/> <br/>", "<br/>") // clean spaces between breaks

      .replaceAll("<br><br>", "<br>"); // fallback

    //   setButtons(contacts);

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("name", this.state.name);

    formData.append("subjectTemplate", this.state.subjectTemplate);

    // formData.append("bodyTemplate", this.state.bodyTemplate);

    formData.append(
      "bodyTemplate",

      `<div style="text-align: justify;">${cleanBodyTemplate}</div>`
    );

    formData.append("isHtml", this.state.isHtml);

    formData.append("variablesJSON", this.state.variablesJSON);

    formData.append("isActive", this.state.isActive);

    formData.append("dummyOne", this.state.dummyOne);

    formData.append("dummyTwo", this.state.dummyTwo);

    formData.append("dummyThree", this.state.dummyThree);

    formData.append("dummyFour", this.state.dummyFour);

    formData.append("dummyFive", this.state.dummyFive);

    formData.append("to", this.state.to);

    formData.append("cc", this.state.cc);

    formData.append("bcc", this.state.bcc);

    formData.append("attachment", this.state.attachment);

    formData.append(
      "isTemplatehasAttachment",
      this.state.isTemplatehasAttachment
    );
    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Emailtemplates/add", {
      // Enter your IP address here

      method: "POST",

      //headers :{ 'Content-Type' : 'application/json'},

      mode: "cors",

      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.EmailtemplatesfetchHandler();

          this.handleOffcanvasClose();

          this.setState({
            name: "",

            subjectTemplate: "",

            bodyTemplate: "",

            isHtml: "",

            variablesJSON: "",

            isActive: "",

            dummyOne: "",

            dummyTwo: "",

            dummyThree: "",

            dummyFour: "",

            dummyFive: "",

            to: "",

            cc: "",

            bcc: "",

            attachment: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  EmailtemplatesupdateHandler = (e) => {
    e.preventDefault();

    let cleanBodyTemplate = this.state.bodyTemplate

      .replaceAll('<p class="ql-align-justify">', "")

      .replaceAll("<p>", "")

      .replaceAll("</p>", "<br/>") // convert end of paragraph to a line break

      .replaceAll("<br/><br/>", "<br/>") // prevent double breaks

      .replaceAll("<br/> <br/>", "<br/>") // clean spaces between breaks

      .replaceAll("<br><br>", "<br>"); // fallback

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("emailtemplates_Id", this.state.emailtemplates_Id);

    formData.append("name", this.state.name);

    formData.append("subjectTemplate", this.state.subjectTemplate);

    // formData.append("bodyTemplate", this.state.bodyTemplate);

    formData.append(
      "bodyTemplate",

      `<div style="text-align: justify;">${cleanBodyTemplate}</div>`
    );

    formData.append("isHtml", this.state.isHtml);

    formData.append("variablesJSON", this.state.variablesJSON);

    formData.append("isActive", this.state.isActive);

    formData.append("dummyOne", this.state.dummyOne);

    formData.append("dummyTwo", this.state.dummyTwo);

    formData.append("dummyThree", this.state.dummyThree);

    formData.append("dummyFour", this.state.dummyFour);

    formData.append("dummyFive", this.state.dummyFive);

    formData.append("to", this.state.to);

    formData.append("cc", this.state.cc);

    formData.append("bcc", this.state.bcc);

    formData.append("attachment", this.state.attachment);

    formData.append(
      "isTemplatehasAttachment",
      this.state.isTemplatehasAttachment
    );
    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Emailtemplates/update", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.EmailtemplatesfetchHandler();

          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  componentDidMount() {
    this.EmailtemplatesfetchHandler();

    //***componentDidMount
  }
  toggleSource = () => {
    this.setState((prevState) => ({
      showSource: !prevState.showSource,
    }));
  };
  handlenameChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ name: fieldValue });
  };

  handlesubjectTemplateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ subjectTemplate: fieldValue });
  };

  handlebodyTemplateChange = (value) => {
    // e.preventDefault();

    // const fieldValue = e.target.value;

    // this.setState({ bodyTemplate: fieldValue });

    this.setState({
      bodyTemplate: value,
    });
  };
  handleSourceChange = (e) => {
    this.setState({ bodyTemplate: e.target.value });
  };
  handleisHtmlChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ isHtml: fieldValue });
  };

  handlevariablesJSONChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ variablesJSON: fieldValue });
  };

  handleisActiveChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ isActive: fieldValue });
  };

  handleToChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ to: fieldValue });
  };

  handleCCChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ cc: fieldValue });
  };

  handleBCCChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ bcc: fieldValue });
  };

  handleAttachmentChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ attachment: fieldValue });
  };

  handledummyOneChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyOne: fieldValue });
  };

  handledummyTwoChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyTwo: fieldValue });
  };

  handledummyThreeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyThree: fieldValue });
  };

  handledummyFourChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyFour: fieldValue });
  };

  handledummyFiveChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyFive: fieldValue });
  };

  // Test email handlers

  handleTestEmail = (row) => {
    let variables = {};

    // If template has variablesJSON (comma-separated or JSON), parse it

    if (row.variablesJSON) {
      try {
        // If it's JSON string like {"to":"", "cc":""}

        variables = JSON.parse(row.variablesJSON);
      } catch (e) {
        // If it's comma-separated string like "to,cc,bcc"

        const keys = row.variablesJSON.split(",").map((k) => k.trim());

        keys.forEach((key) => {
          variables[key] = ""; // default empty value
        });
      }
    }

    this.setState({
      showTestModal: true,

      selectedTemplate: row,

      testEmail: "",
      isTemplatehasAttachment: row.isTemplatehasAttachment,
      testVariables: variables, // keep as object
    });
  };

  handleVariableChange = (key, value) => {
    this.setState((prevState) => ({
      testVariables: {
        ...prevState.testVariables,

        [key]: value,
      },
    }));
  };

  handlePreview = (row) => {
    this.setState({
      selectedTemplate: row,

      generatingPreview: true,
    });

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("templateId", row.emailtemplates_Id);

    formData.append("variables", row.variablesJSON || "{}");

    fetch(configData.api_url + "EmailSender/previewTemplate", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.setState({ generatingPreview: false });

        if (data.status === "success") {
          this.setState({
            showPreviewModal: true,

            previewData: data.data,
          });
        } else {
          this.showToast(data.message, "error");
        }
      })

      .catch((error) => {
        this.setState({ generatingPreview: false });

        this.showToast("Error generating preview", "error");
      });
  };

  sendTestEmail = () => {
    // if (!this.state.testEmail || !this.state.testEmail.includes("@")) {

    //   this.showToast("Please enter a valid test email address", "error");

    //   return;

    // }

    this.setState({ sendingTest: true });

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append(
      "templateId",

      this.state.selectedTemplate.emailtemplates_Id
    );

    formData.append("testEmail", this.state.selectedTemplate.name);
    const variablesWithAttachment = {
      ...this.state.testVariables,
      isTemplatehasAttachment: this.state.isTemplatehasAttachment,
    };

    formData.append("variables", JSON.stringify(variablesWithAttachment));

    fetch(configData.api_url + "EmailSender/testTemplate", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.setState({ sendingTest: false });

        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.setState({
            showTestModal: false,

            testEmail: "",

            testVariables: "",
          });
        }
      })

      .catch((error) => {
        this.setState({ sendingTest: false });

        this.showToast("Error sending test email", "error");
      });
  };

  handleTestEmailChange = (e) => {
    this.setState({ selectedTemplate: e.target.value });
  };
  // handleTestFileChange = (e) => {
  //   const file = e.target.files[0];
  //   this.setState({ isTemplatehasAttachment: file });
  // };
  handleTestFileChange = (e) => {
    // const file = e.target.files[0];
    // this.setState({
    //   isTemplatehasAttachment: file ? `{ ${file.name} }` : "",
    // });
    this.setState({ isTemplatehasAttachment: e.target.value });
  };
  handleTestVariablesChange = (e) => {
    this.setState({ testVariables: e.target.value });
  };

  closeTestModal = () => {
    this.setState({
      showTestModal: false,

      testEmail: "",

      testVariables: "",

      selectedTemplate: null,
    });
  };

  closePreviewModal = () => {
    this.setState({
      showPreviewModal: false,

      previewData: null,

      selectedTemplate: null,
    });
  };

  handleisTemplatehasAttachmentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ isTemplatehasAttachment: fieldValue });
    // const file = e.target.files[0];
    // this.setState({ isTemplatehasAttachment: file });
  }; //***inputFunctions
  handleisTemplatehasAttachmentsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ isTemplatehasAttachments: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];

    const index = oldData.index;

    data[index] = newData;

    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);

    // implement your edit logic here
  };

  handleDelete = (row, index) => {
    var formData = new FormData();

    formData.append("emailtemplates_Id", row.emailtemplates_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Emailtemplates/delete", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.EmailtemplatesfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();

    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });

    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage
      );
    const modules = {
      toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["code-block"],
        ["link", "image", "video"],
        ["clean"],
        // Add other toolbar buttons you want here
      ],
    };
    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline

                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Email Templates
                      </h3>
                    </div>

                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "700px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Email Templates</Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Template Name
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlenameChange}
                                        className="form-control"
                                        name="name"
                                        value={this.state.name}
                                        required="required"
                                        placeholder="Enter Template Name"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.name}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Variables JSON
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        as="textarea"
                                        rows={4}
                                        onChange={
                                          this.handlevariablesJSONChange
                                        }
                                        className="form-control"
                                        name="variablesJSON"
                                        value={this.state.variablesJSON}
                                        required="required"
                                        placeholder="Enter Variables JSON"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.variablesJSON}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Subject
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlesubjectTemplateChange
                                        }
                                        className="form-control"
                                        name="subjectTemplate"
                                        value={this.state.subjectTemplate}
                                        required="required"
                                        placeholder="Enter Subject Template"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.subjectTemplate}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Is Html
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Select
                                        onChange={this.handleisHtmlChange}
                                        className="form-control"
                                        name="isHtml"
                                        value={this.state.isHtml}
                                        required="required"
                                        placeholder="Enter Is Html"
                                      >
                                        <option>Select </option>

                                        <option value="YES">YES</option>

                                        <option value="NO">NO</option>
                                      </Form.Select>
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.isHtml}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Is Active
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Select
                                        onChange={this.handleisActiveChange}
                                        className="form-control"
                                        name="isActive"
                                        value={this.state.isActive}
                                        required="required"
                                        placeholder="Enter Is Active"
                                      >
                                        <option>Select </option>
                                        <option value="YES">YES</option>
                                        <option value="NO">NO</option>
                                      </Form.Select>
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.isActive}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Container Height
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyOneChange}
                                        className="form-control"
                                        name="dummyOne"
                                        value={this.state.dummyOne}
                                        required="required"
                                        placeholder="Enter Container Height"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyOne}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Container Weight
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyTwoChange}
                                        className="form-control"
                                        name="dummyTwo"
                                        value={this.state.dummyTwo}
                                        required="required"
                                        placeholder="Enter Container Weight"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyTwo}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        TO
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleToChange}
                                        className="form-control"
                                        name="to"
                                        value={this.state.to}
                                        required="required"
                                        placeholder="Enter TO"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.to}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        CC
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleCCChange}
                                        className="form-control"
                                        name="cc"
                                        value={this.state.cc}
                                        required="required"
                                        placeholder="Enter CC"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.cc}{" "}
                                    </div>
                                  </Row>

                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        BCC
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleBCCChange}
                                        className="form-control"
                                        name="bcc"
                                        value={this.state.bcc}
                                        required="required"
                                        placeholder="Enter BCC"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.bcc}{" "}
                                    </div>
                                  </Row>

                                  <br />
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Does Template have Attachments
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        onChange={
                                          this
                                            .handleisTemplatehasAttachmentChange
                                        }
                                        className="form-control"
                                        name="isTemplatehasAttachment"
                                        value={
                                          this.state.isTemplatehasAttachment
                                        }
                                        required="required"
                                        placeholder="Enter Is Template has Attachment"
                                      >
                                        <option>Select </option>
                                        <option value="YES">YES</option>
                                        <option value="NO">NO</option>
                                      </Form.Select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors
                                          .isTemplatehasAttachment
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {this.state.isTemplatehasAttachment ===
                                    "YES" && (
                                      <Row style={{ marginTop: "10px" }}>
                                        <Col lg="4" md="4">
                                          <Form.Label>
                                            Upload Attachment
                                          </Form.Label>
                                        </Col>
                                        <Col lg="8" md="8">
                                          <Form.Select
                                            onChange={
                                              this
                                                .handleisTemplatehasAttachmentsChange
                                            }
                                            className="form-control"
                                            name="isTemplatehasAttachments"
                                            value={
                                              this.state.isTemplatehasAttachments
                                            }
                                            required="required"
                                            placeholder="Enter Is Template has Attachment"
                                          >
                                            <option>Select </option>
                                            <option value="Backgroundimage">
                                              Background Image
                                            </option>
                                            <option value="Attachment">
                                              Attachment
                                            </option>
                                            <option value="Header">Header</option>
                                            <option value="Body">Body</option>
                                            <option value="Footer">Footer</option>
                                          </Form.Select>
                                        </Col>
                                      </Row>
                                    )}
                                  <br />
                                  <Row>
                                    <Col lg="12" md="12" sm="12">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Body Template &nbsp;&nbsp;&nbsp;
                                        <Button
                                          onClick={this.toggleSource}
                                          style={{ marginTop: 10 }}
                                        >
                                          {this.state.showSource
                                            ? "Editor"
                                            : "HTML"}
                                        </Button>
                                      </Form.Label>
                                    </Col>

                                    <Col lg="12" md="12" sm="12">
                                      {this.state.showSource ? (
                                        <textarea
                                          value={this.state.bodyTemplate}
                                          onChange={this.handleSourceChange}
                                          style={{
                                            width: "100%",
                                            height: "450px",
                                          }}
                                          placeholder="Edit HTML source"
                                        />
                                      ) : (
                                        <ReactQuill
                                          name="bodyTemplate"
                                          value={this.state.bodyTemplate}
                                          theme="snow"
                                          ref={this.quillRef}
                                          onChange={
                                            this.handlebodyTemplateChange
                                          }
                                          modules={modules}
                                          style={{ height: "450px" }}
                                        />
                                      )}
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.bodyTemplate}{" "}
                                    </div>
                                  </Row>

                                  {/* tableContent */}
                                </Form>
                              </Row>
                            </Row>

                            <br />

                            <br />

                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.EmailtemplatessubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {this.state.isEditing && (
                        // Edit Offcanvas

                        <Offcanvas
                          show={this.state.isEditing}
                          // onHide={() => this.setState({ isEditing: false })}

                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "950px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Emailtemplates
                            </Offcanvas.Title>
                          </Offcanvas.Header>

                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Template Name
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlenameChange}
                                          className="form-control"
                                          name="name"
                                          value={this.state.name}
                                          required="required"
                                          placeholder="Enter Template Name"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.name}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Variables JSON
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          as="textarea"
                                          rows={4}
                                          onChange={
                                            this.handlevariablesJSONChange
                                          }
                                          className="form-control"
                                          name="variablesJSON"
                                          value={this.state.variablesJSON}
                                          required="required"
                                          placeholder="Enter Variables JSON"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.variablesJSON}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Subject
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlesubjectTemplateChange
                                          }
                                          className="form-control"
                                          name="subjectTemplate"
                                          value={this.state.subjectTemplate}
                                          required="required"
                                          placeholder="Enter Subject Template"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.subjectTemplate}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Is Html
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Select
                                          onChange={this.handleisHtmlChange}
                                          className="form-control"
                                          name="isHtml"
                                          value={this.state.isHtml}
                                          required="required"
                                          placeholder="Enter Is Html"
                                        >
                                          <option>Select </option>

                                          <option value="Yes">Yes</option>

                                          <option value="No">No</option>
                                        </Form.Select>
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.isHtml}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Is Active
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Select
                                          onChange={this.handleisActiveChange}
                                          className="form-control"
                                          name="isActive"
                                          value={this.state.isActive}
                                          required="required"
                                          placeholder="Enter Is Active"
                                        >
                                          <option>Select </option>

                                          <option value="YES">Yes</option>

                                          <option value="NO">No</option>
                                        </Form.Select>
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.isActive}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Container Height
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledummyOneChange}
                                          className="form-control"
                                          name="dummyOne"
                                          value={this.state.dummyOne}
                                          required="required"
                                          placeholder="Enter Container Height"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dummyOne}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Container Weight
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledummyTwoChange}
                                          className="form-control"
                                          name="dummyTwo"
                                          value={this.state.dummyTwo}
                                          required="required"
                                          placeholder="Enter Container Weight"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dummyTwo}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          TO
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleToChange}
                                          className="form-control"
                                          name="to"
                                          value={this.state.to}
                                          required="required"
                                          placeholder="Enter TO"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.to}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          CC
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleCCChange}
                                          className="form-control"
                                          name="cc"
                                          value={this.state.cc}
                                          required="required"
                                          placeholder="Enter CC"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.cc}{" "}
                                      </div>
                                    </Row>

                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          BCC
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleBCCChange}
                                          className="form-control"
                                          name="bcc"
                                          value={this.state.bcc}
                                          required="required"
                                          placeholder="Enter BCC"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.bcc}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Does Template have Attachments
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                          onChange={
                                            this
                                              .handleisTemplatehasAttachmentChange
                                          }
                                          className="form-control"
                                          name="isTemplatehasAttachment"
                                          value={
                                            this.state.isTemplatehasAttachment
                                          }
                                          required="required"
                                          placeholder="Enter Is Template has Attachment"
                                        >
                                          <option>Select </option>
                                          <option value="YES">YES</option>
                                          <option value="NO">NO</option>
                                        </Form.Select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors
                                            .isTemplatehasAttachment
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Body Template &nbsp;&nbsp;&nbsp;
                                          <Button
                                            onClick={this.toggleSource}
                                            style={{ marginTop: 10 }}
                                          >
                                            {this.state.showSource
                                              ? "Editor"
                                              : "HTML"}
                                          </Button>
                                        </Form.Label>
                                      </Col>

                                      <Col lg="12" md="12" sm="12">
                                        {this.state.showSource ? (
                                          <textarea
                                            value={this.state.bodyTemplate}
                                            onChange={this.handleSourceChange}
                                            style={{
                                              width: "100%",
                                              height: "450px",
                                            }}
                                            placeholder="Edit HTML source"
                                          />
                                        ) : (
                                          <ReactQuill
                                            name="bodyTemplate"
                                            value={this.state.bodyTemplate}
                                            theme="snow"
                                            ref={this.quillRef}
                                            onChange={
                                              this.handlebodyTemplateChange
                                            }
                                            modules={modules}
                                            style={{ height: "450px" }}
                                          />
                                        )}
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.bodyTemplate}{" "}
                                      </div>
                                    </Row>

                                    {/* tableContent */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{
                                    marginRight: "50px",
                                    marginTop: "60px",
                                  }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.EmailtemplatesupdateHandler}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}

                      {/*offcanvas is over */}
                    </Col>
                  </Row>

                  <br />

                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}

                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />

                      <Button
                        variant="primary"
                        className="bi bi-plus "
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        paginationRowsPerPageOptions={[
                          10, 20, 30, 50, 60, 70, 80, 90, 100,
                        ]}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Test Email Modal */}

        <Modal
          show={this.state.showTestModal}
          onHide={this.closeTestModal}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Email Template</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {this.state.selectedTemplate && (
              <div>
                {/* <p>

                  <strong>Template:</strong> {this.state.selectedTemplate.name}

                </p> */}

                <Form>
                  <Row className="mb-2">
                    <Col lg="3" md="3">
                      <Form.Label>Template Name</Form.Label>
                    </Col>
                    <Col lg="9" md="9">
                      <Form.Control
                        type="text"
                        placeholder="Enter Template Name"
                        value={this.state.selectedTemplate.name}
                        onChange={this.handleTestEmailChange}
                        required
                        disabled
                      />
                    </Col>
                  </Row>
                  {this.state.testVariables &&
                    Object.keys(this.state.testVariables).map((key, index) => {
                      // Custom mapping for known keys
                      const labelMap = {
                        to: "To",
                        cc: "Cc",
                        bcc: "Bcc",
                      };
                      // Fallback: convert snake_case → Title Case
                      const displayLabel =
                        labelMap[key] ||
                        key
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase());
                      return (
                        <Row className="mb-2" key={index}>
                          <Col lg="3" md="3">
                            <Form.Label>{displayLabel}</Form.Label>
                          </Col>
                          <Col lg="9" md="9">
                            <Form.Control
                              type="text"
                              value={this.state.testVariables[key]}
                              onChange={(e) =>
                                this.handleVariableChange(key, e.target.value)
                              }
                            />
                          </Col>
                        </Row>
                      );
                    })}
                  {this.state.isTemplatehasAttachment === "YES" && (
                    <Row className="mb-3">
                      <Col lg="3" md="3">
                        <Form.Label>Attachments</Form.Label>
                      </Col>
                      <Col lg="9" md="9">
                        <Form.Control
                          type="text"
                          placeholder="Enter Attachments"
                          //value={this.state.isTemplatehasAttachment}
                          onChange={this.handleTestFileChange}
                          required
                        />
                      </Col>
                    </Row>
                  )}
                </Form>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeTestModal}>
              Cancel
            </Button>

            <Button
              variant="primary"
              onClick={this.sendTestEmail}
              disabled={this.state.sendingTest}
            >
              {this.state.sendingTest ? "Sending..." : "Send Email"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Preview Email Modal */}
        <Modal
          show={this.state.showPreviewModal}
          onHide={this.closePreviewModal}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Email Template Preview</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {this.state.previewData && (
              <div>
                <Row className="mb-3">
                  <Col lg="2" md="2">
                    <strong>Template:</strong>
                  </Col>

                  <Col lg="10" md="10">
                    {this.state.previewData.template.name}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col lg="2" md="2">
                    <strong>Subject:</strong>
                  </Col>

                  <Col lg="10" md="10">
                    {this.state.previewData.processedSubject}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col lg="2" md="2">
                    <strong>Variables Used:</strong>
                  </Col>

                  <Col lg="10" md="10">
                    <pre
                      style={{
                        backgroundColor: "#f8f9fa",

                        padding: "10px",

                        borderRadius: "4px",
                      }}
                    >
                      {JSON.stringify(
                        this.state.previewData.variables,

                        null,

                        2
                      )}
                    </pre>
                  </Col>
                </Row>

                <Row>
                  <Col lg="2" md="2">
                    <strong>Body Preview:</strong>
                  </Col>

                  <Col lg="10" md="10">
                    <div
                      style={{
                        border: "1px solid #dee2e6",

                        borderRadius: "4px",

                        padding: "15px",

                        backgroundColor: "#fff",

                        minHeight: "200px",

                        maxHeight: "400px",

                        overflow: "auto",
                      }}
                    >
                      {this.state.previewData.isHtml ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: this.state.previewData.processedBody,
                          }}
                        />
                      ) : (
                        <pre style={{ whiteSpace: "pre-wrap" }}>
                          {this.state.previewData.processedBody}
                        </pre>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.closePreviewModal}>
              Close
            </Button>

            {this.state.selectedTemplate && (
              <Button
                variant="success"
                onClick={() => {
                  this.closePreviewModal();

                  this.handleTestEmail(this.state.selectedTemplate);
                }}
              >
                Send Test Email
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
